import { ReactNode } from "react";
import { useAppSelector } from "../store";
import { selectTheme } from "../store/theme";

export const ThemeWrapper = ({ children }: { children: ReactNode }) => {
    const { color, mode, theme } = useAppSelector(selectTheme);

    return <div className={`${theme} ${mode} ${color} ${theme}--${mode} ${mode}--${color} ${theme}--${color}--${mode} _text-color`}>{children}</div>
}